import {
  urlParams,
  RSAencrypt,
  RSAdecrypt,
  setToken,
  removeToken,
  getToken,
  setStore,
  getStore,
  removeStore,
  isURL,
  validatenull,
  mqConnnect as mqStore
} from '@/util'
import { getUserInfo, getRouter, logout } from '@/api/user'
import { loginBySmsCode, refreshToken } from '@/api/login'
import webiste from '@/config/website'
import { cloneDeep, isEmpty } from 'lodash-es'
const { doSubscribe, destroyConnection } = mqStore()

const getCommonMenu = (menuItem) => {
  if (!isEmpty(getStore({ name: 'commonMenu' }))) {
    const commonMenu = getStore({ name: 'commonMenu' })
    commonMenu.sort((a, b) => {
      // 如果a没有clickCount属性，则排在后面
      if (!a.clickCount) return 1
      // 如果b没有clickCount属性，则排在后面
      if (!b.clickCount) return -1
      // 根据clickCount属性进行比较
      return b.clickCount - a.clickCount
    })
    const topMenu = commonMenu.slice(0, 6)
    const item = menuItem.filter((item) => item.permission !== 'common_menu')
    const parentList = cloneDeep([].concat(...item.map((obj) => obj.children)))

    const list = []
    topMenu.forEach((obj) => {
      parentList.forEach((item) => {
        if (obj.parentId === item.id) {
          const newObj = Array.isArray(item.children)
            ? item.children.find((item) => item.id === obj.id)
            : ''
          const _obj = newObj || obj
          const index = list.findIndex((ch) => item.id === ch.id)
          if (index !== -1) {
            list[index].children.push(_obj)
          } else {
            list.push({
              ...item,
              children: [_obj]
            })
          }
        }
      })
    })
    const children = list
    menuItem[0].children = children
  } else {
    const permission = [
      'driver_manage',
      'vehicle_manage',
      'order_ticketsche',
      'order_intercity',
      'order_ferry',
      'transport_bound'
    ]
    const children = []
    const commonMenu = []
    menuItem[0].children = []
    menuItem.forEach((item) => {
      item.children.forEach((obj) => {
        const parent = cloneDeep(obj)
        parent.children = []
        obj.children.forEach((ch) => {
          if (permission.includes(ch.permission)) {
            commonMenu.push(ch)
            const index = children.findIndex((c) => c.id === parent.id)
            if (index !== -1) {
              children[index].children.push(ch)
              return
            }
            children.push({
              ...parent,
              children: [ch]
            })
          }
        })
      })
    })
    menuItem[0].children = children
    setStore({ name: 'commonMenu', content: commonMenu })
  }
  return menuItem
}
function addPath(ele, first) {
  const menu = webiste.menu
  const propsConfig = menu.props
  const propsDefault = {
    label: propsConfig.label || 'name',
    path: propsConfig.path || 'path',
    icon: propsConfig.icon || 'icon',
    children: propsConfig.children || 'children',
    meta: propsConfig.meta || 'meta'
  }
  let meta = ele[propsDefault.meta] || {}
  let path = ele[propsDefault.path] || ''
  if (path && path.indexOf('?' !== -1)) {
    const extra = urlParams(path)
    meta = {
      ...meta,
      ...extra
    }
    path = path.replace(/([\\?].*)/gi, '')
  }
  ele[propsDefault.path] = path
  ele[propsDefault.meta] = meta
  const icon = ele[propsDefault.icon]
  ele[propsDefault.icon] = validatenull(icon) ? menu.iconDefault : icon
  const isChild = ele[propsDefault.children] && ele[propsDefault.children].length !== 0
  if (!isChild) ele[propsDefault.children] = []
  if (!isChild && first && !isURL(ele[propsDefault.path])) {
    ele[propsDefault.path] = ele[propsDefault.path] + '/index'
  } else {
    ele[propsDefault.children].forEach((child) => {
      addPath(child)
    })
  }
}

const user = {
  state: {
    userInfo: {},
    permission: {},
    acpermission: getStore({ name: 'acpermission' }) || [],
    roles: [],
    menuId: {},
    menu: getStore({ name: 'menu' }) || [],
    menuAll: [],
    token: getToken() || '',
    refreshToken: '',
    logoutType: '' // 设备登出类型  2 同类型设备登录同一账号导致一方下线  3其它类型设备控制此设备下线
  },
  actions: {
    // 根据用户名登录
    // LoginByUsername ({ commit }, userInfo = {}) {
    //   const user = encryption({
    //     data: userInfo,
    //     type: 'Aes',
    //     key: 'avue',
    //     param: ['useranme', 'password']
    //   });
    //   return new Promise((resolve) => {
    //     loginByUsername(user.username, user.password, userInfo.code, userInfo.redomStr).then(res => {
    //       const data = res.data.data;
    //       commit('SET_TOKEN', data);
    //       commit('DEL_ALL_TAG');
    //       commit('CLEAR_LOCK');
    //       resolve();
    //     })
    //   })
    // },
    subScribeMessage({ state }, cb) {
      if (!state.userInfo.userId) {
        return
      }
      const tempTopic = `sys:push:new:user:${state.userInfo.userId}`
      doSubscribe(tempTopic, (res, topic) => {
        if (res && topic === tempTopic) {
          cb && cb(JSON.parse(res))
        }
      })
    },
    /**
     * 订阅登录登出消息
     * state 1 其它设备登录通知此设备  3其它设备退出登录通知此设备  2同类型设备登录通知此设备  4pc端被强制下线
     */
    subScribeLogout({ state, dispatch, commit }, cb) {
      if (!state.token) {
        return
      }
      // console.log('开启登录登出消息订阅：')
      const tempTopic = `sys:user:login:msg:${state.token}`
      doSubscribe(
        tempTopic,
        (rel, topic) => {
          if (!rel || topic !== tempTopic) {
            return
          }
          const state = JSON.parse(rel)
          // console.log('登录登出接收到了订阅消息:', state)
          if (state === 2) {
            dispatch('LogOut').then((res) => {
              if (res.code !== 0) {
                return
              }
              cb && cb(state)
              commit('SET_LOGOUTTYPE', state)
            })
          }
          if (state === 4) {
            cb && cb(state)
            commit('SET_LOGOUTTYPE', state)
            commit('SET_MENU', [])
          }
        },
        { qos: 2 }
      )
    },
    // 根据手机号登录
    LoginByPhone({ commit, dispatch }, userInfo) {
      const { username, password, grantType, smsCode } = userInfo || {}
      const params = {
        client_id: webiste.auth.client_id,
        client_secret: webiste.auth.client_secret,
        grant_type: grantType || webiste.auth.grant_type,
        username,
        password,
        smsCode
      }
      // 加密处理
      if (params.password) {
        params.password = RSAencrypt(params.password)
      }
      return loginBySmsCode(params).then((res) => {
        const { code, data } = res || {}
        if (code !== 0) {
          return res
        }
        dispatch('SetLoginToken', data)
        return res
      })
    },
    SetLoginToken({ commit }, data) {
      const { token, refreshToken, additionalInformation = {} } = data || {}
      const { clientValue = '' } = additionalInformation
      if (clientValue) {
        const key = RSAdecrypt(clientValue)
        setStore({ name: 'RANDOM_DEVICE_UNIQUE_KEY', content: key })
      }
      commit('SET_TOKEN', token)
      commit('SET_REFRESH_TOKEN', refreshToken)
      commit('DEL_ALL_TAG')
      commit('CLEAR_LOCK')
    },
    GetUserInfo({ commit }) {
      return getUserInfo().then((res) => {
        const { code, data } = res || {}
        console.log('data:', data)
        if (code !== 0) {
          return res
        }
        const { merchantId, permission } = data || {}
        window.localStorage.setItem('merchantId', merchantId)
        commit('SET_USERIFNO', data)
        commit('SET_ACP_PERMISSION', permission)
        return res
      })
    },
    // 刷新token
    RefreshToken({ commit, state }) {
      return new Promise((resolve, reject) => {
        refreshToken(state.refreshToken)
          .then((res) => {
            const data = res.data
            commit('SET_TOKEN', data)
            resolve(data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout()
          .then((res) => {
            commit('SET_TOKEN', '')
            commit('SET_MENUALL_NULL', [])
            commit('SET_MENU', [])
            // commit('SET_COMMON_MENU', [])
            commit('SET_TAG_LIST', [])
            commit('SET_ROLES', [])
            commit('DEL_ALL_TAG', [])
            commit('CLEAR_LOCK')
            commit('SET_ACP_PERMISSION', [])
            commit('SET_USERIFNO', {})
            removeStore({ name: 'RANDOM_DEVICE_UNIQUE_KEY' })
            removeToken()
            destroyConnection()
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 注销session
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_MENUALL_NULL', [])
        commit('SET_MENU', [])
        commit('SET_TAG_LIST', [])
        commit('SET_ROLES', [])
        commit('DEL_ALL_TAG', [])
        commit('SET_ACP_PERMISSION', [])
        commit('CLEAR_LOCK')
        commit('SET_USERIFNO', {})
        removeStore({ name: 'RANDOM_DEVICE_UNIQUE_KEY' })
        removeToken()
        resolve()
      })
    },
    // 获取系统菜单
    GetMenu({ commit }) {
      return new Promise((resolve, reject) => {
        // let menu = getStore({ name: 'menu' })
        // if (!isEmpty(menu)) {
        //   commit('SET_MENUALL', menu)
        //   menu = getCommonMenu(menu)
        //   commit('SET_MENU', menu)
        //   resolve(menu)
        //   return
        // }
        const params = {
          lazy: 0,
          parentId: 0
        }
        getRouter(params).then((res) => {
          const data = res.data
          let menu = cloneDeep(data)
          menu.unshift({
            action: 0,
            id: -1,
            isHide: false,
            isOpen: false,
            label: '常用菜单',
            level: 1,
            name: '常用菜单',
            parentId: '-1',
            permission: 'common_menu',
            selectedIcon: 'https://qiniu-sys.ayundi.cn/icon/plat/1691566937814Frame-3.png',
            sort: -99,
            type: 0,
            unselectedIcon: 'https://qiniu-sys.ayundi.cn/icon/plat/1691566941601Frame-2.png'
          })
          menu.forEach((ele) => addPath(ele, true))
          commit('SET_MENUALL', menu)
          menu = getCommonMenu(menu)
          menu = menu.filter((item) => {
            if (item.children) {
              return item.children.length > 0 || !isEmpty(item.children)
            }
            return item.children
          })
          commit('SET_MENU', menu)
          resolve(menu)
        })
      })
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      setToken(token)
      state.token = token
      setStore({ name: 'token', content: state.token })
    },
    SET_REFRESH_TOKEN: (state, rtoken) => {
      state.refreshToken = rtoken
      setStore({ name: 'rtoken', content: state.refreshToken })
    },
    SET_MENUID(state, menuId) {
      state.menuId = menuId
    },
    SET_USERIFNO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_MENU_ALL: (state, menuAll) => {
      state.menuAll = menuAll
      setStore({ name: 'menuAll', content: state.menuAll })
    },
    SET_MENU: (state, menu) => {
      state.menu = menu
      setStore({ name: 'menu', content: state.menu })
      if (validatenull(menu)) return
      // 合并动态路由去重
      let menuAll = state.menuAll
      menuAll = menuAll.concat(menu).reverse()
      const newMenu = []
      for (const item1 of menuAll) {
        let flag = true
        for (const item2 of newMenu) {
          if (item1.name === item2.name || item1.path === item2.path) {
            flag = false
          }
        }
        if (flag) newMenu.push(item1)
      }
      state.menuAll = newMenu
      setStore({ name: 'menuAll', content: state.menuAll })
    },
    SET_MENUALL_NULL: (state) => {
      state.menuAll = []
      setStore({ name: 'menuAll', content: state.menuAll })
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSION: (state, permission) => {
      state.permission = {}
      permission.forEach((ele) => {
        state.permission[ele] = true
      })
    },
    SET_ACP_PERMISSION: (state, permission) => {
      state.acpermission = permission
      setStore({ name: 'acpermission', content: state.acpermission })
    },

    SET_LOGOUTTYPE: (state, logoutType) => {
      state.logoutType = logoutType
    },
    SET_COMMON_MENU: (state, commonMenu) => {
      setStore({ name: 'commonMenu', content: commonMenu })
    }
  }
}
export default user
